import axios, { AxiosResponse } from "axios";

import {
	getRequest,
	postRequest,
	deleteRequest,
	putRequest
} from "@/Utils/Service/BackendService";
import { DeletedRecord } from "@/Contracts";
import {
	buildSearchableQueryString,
	EMAIL_TEMPLATE_ATLAS_SAFE_FIELDS
} from "@/Services/_shared/buildSearchableQueryUrl";
import { MergeTagVariable } from "@/Contracts/Documents";
import {
	EmailTemplateRequest,
	EmailTemplatesResponse,
	EmailTemplate,
	EmailTemplateGetRequest,
	CustomTemplateType,
	PreviewEmailTemplateRequest
} from "@/Contracts/EmailTemplates";

const getAllTemplatesUrl = "/v2/email/templates";
const getOneTemmplateUrl = "/v2/email/templates/{template_id}";
const addEmailTemplatesUrl = "/v2/email/templates";
const deleteEmailTemplateUrl = "/v2/email/templates/{template_id}";
const updateEmailTemplateUrl = "/v2/email/templates/{template_id}";
const fetchMergeTagVariables = "/v2/emails/merge_tags";
const previewEmailtemplateUrl = "/v2/email/templates/preview";
const searchEmailTemplatesUrl = "v2/email/templates/search";

export const searchEmailTemplates = async (
	keyword = ""
): Promise<EmailTemplatesResponse> => {
	const url = `${searchEmailTemplatesUrl}?q=${keyword}`;
	try {
		const response: AxiosResponse<EmailTemplatesResponse> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getAllTemplates = async (
	getEmailTemplateRequest: EmailTemplateGetRequest
): Promise<EmailTemplatesResponse> => {
	const queryString = buildSearchableQueryString({
		filters: getEmailTemplateRequest.filters,
		keywords: getEmailTemplateRequest.keywords,
		safeFields: EMAIL_TEMPLATE_ATLAS_SAFE_FIELDS,
		modelLabel: "EmailTemplate"
	});
	const url = queryString
		? `${getAllTemplatesUrl}?${queryString}`
		: getAllTemplatesUrl;
	try {
		const response: AxiosResponse<EmailTemplatesResponse> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const addEmailTemplate = async (
	addEmailTemplateRequest: EmailTemplateRequest
): Promise<EmailTemplate> => {
	try {
		const response: AxiosResponse<EmailTemplate> = await axios(
			postRequest(
				addEmailTemplatesUrl,
				addEmailTemplateRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const deleteEmailTemplate = async (
	templateId: string
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteEmailTemplateUrl.replace("{template_id}", templateId),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getOneEmailTemplate = async (
	templateId: string
): Promise<EmailTemplate> => {
	try {
		const response: AxiosResponse<EmailTemplate> = await axios(
			getRequest(
				getOneTemmplateUrl.replace("{template_id}", templateId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateEmailTemplate = async (
	emailTemplateId: string,
	updateEmailTemplateRequest: EmailTemplateRequest
): Promise<EmailTemplate> => {
	try {
		const response: AxiosResponse<EmailTemplate> = await axios(
			putRequest(
				updateEmailTemplateUrl.replace(
					"{template_id}",
					emailTemplateId
				),
				updateEmailTemplateRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getMergeTagVariables = async (): Promise<MergeTagVariable[]> => {
	try {
		const response: AxiosResponse<MergeTagVariable[]> = await axios(
			getRequest(fetchMergeTagVariables, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const fetchSystemEmailTemplateByType = async (
	_customTemplateType: CustomTemplateType
): Promise<EmailTemplatesResponse> => {
	try {
		const url = getAllTemplatesUrl;
		const response: AxiosResponse<EmailTemplatesResponse> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const previewEmailTemplate = async (
	previeEmailTemplateRequest: PreviewEmailTemplateRequest
): Promise<any> => {
	try {
		const reponse: AxiosResponse<any> = await axios(
			postRequest(
				previewEmailtemplateUrl,
				previeEmailTemplateRequest,
				true,
				false,
				false
			)
		);
		return reponse.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
